<template>
  <transition name="slide-fade" mode="out-in">
    <div id="service" v-wechat-title="$route.meta.title">
      <van-nav-bar :title="name" left-arrow @click-left="onClickLeft" />
      <div class="main">
        <div class="main-tit">{{ info.title }}</div>
        <div class="tit2">
          <span class="span1" v-if="info.village"
            >来源：{{ info.village.name }} </span
          >
          <span class="span3">{{ info.create_time }}</span>
          <span class="span3">
            <!-- <van-icon name="eye-o" size="14px" /> -->
            <!-- <span style="margin-left: 0.1rem">{{ info.view }}</span> -->
          </span>
        </div>
        <van-loading size="20px" v-show="loading">加载中...</van-loading>
        <div class="new-content" v-html="content"></div>
        <div class="imgArr" v-for="(item,index) in info.tables" :key="index">
          <img :src="item.image" style="width:100%">
          <div class="img-btn" v-if="item.images.length!=0" @click="toInfos(index)">查看明细</div>
        </div>
       
      </div>
    </div>
  </transition>
</template>
<script>
import { NavBar, Icon, loading } from "vant";
import { getArticleInfo, addView } from "@/api/apiData";
import axios from "axios";

export default {
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [loading.name]: loading,
  },
  data() {
    return {
      id: "",
      info: [],
      content: "",
      loading: true,
      name: "",
      imgs:[]
    };
  },
  mounted() {
    var id = this.$route.query.id;
    var name = this.$route.query.name;
    this.id = id;
    this.name = name;
    this.getArticleInfo();
    // this.addView();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getArticleInfo() {
      let that = this;
      axios
        .post(
          "https://mqzpower.ncscloudmedia.com/index.php/api/article/detail",
          { article_id: that.id }
        )
        .then(function (response) {
          let res = response.data;
          if (res.code == 1) {
            that.info = res.data;
            that.loading = false;
            if (that.info.content != null) {
              var con = that.escape2Html(that.info.content);
              that.content = con;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      // getArticleInfo({ id: this.id }).then((res) => {
      //   if (res.code == 1) {
      //     this.info = res.data;
      //     this.loading = false;
      //     if (this.info.content != null) {
      //       var con = this.escape2Html(this.info.content);
      //       this.content = con;
      //     }
      //   }
      // });
    },
    toInfos(i){
      let id =this.id
      this.$router.push({
        path:'/InfoNew',
        query:{
          index:i,
          id:id
        }
      })
    },
    addView() {
      addView({ id: this.id }).then((res) => {});
    },
    escape2Html(str) {
      var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
      });
    },
    // 点击图片放大
    // imageChange(e) {
    //   console.log(e.target);
    //   this.imgSrc = 'http://mqzreport.ncscloudmedia.com/Upload/image/ueditor/20200916/1600228023196655.png';
    // }
  },
};
</script>
<style scoped>
#service {
  height: 100%;
  background: white;
}
.main {
  padding: 1rem;
  text-align: left;
  background: white;
}
.main-tit {
  font-weight: bold;
  font-size: 1.2rem;
}
.tit2 {
  margin-top: 0.8rem;
  font-size: 0.7rem;
}
.span1 {
  color: #ff1106;
}
.span2 {
  color: #bebebe;
}
.span3 {
  float: right;
  color: #bebebe;
  display: flex;
}
.new-content {
  text-align: left;
  color: #6e6e6e;
  word-break: break-all;
  width: 100%;
}
.new-content >>> img {
  width: 100%;
  margin: 0 auto;
}
.imgArr{
  margin-top: 1rem;
}
.img-btn{
  color: #1989fa;
  font-size:0.8rem;
  padding: 5px;
  border: solid 1px;
  width: fit-content;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/page/newsInfo.vue